import React, { useEffect, useState } from "react";
import "./intro.scss";

export default function Intro() {
  const text = "Software Engineer | Problem Solving & HCI Perspective 🙂";
  const [displayText, setDisplayText] = useState("");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (index < text.length) {
      const timer = setTimeout(() => {
        setDisplayText((prev) => prev + text[index]);
        setIndex((prev) => prev + 1);
      }, 50);

      return () => clearTimeout(timer);
    }
  }, [index]);

  return (
    <div className="intro" id="intro">
      <div className="left">
        <div className="imgConatiner">
          <img src="/assets/other/character.png" alt="character" />
        </div>
      </div>

      <div className="right">
        <div className="wrapper">
          <h2>Hi There, I am</h2>
          <h1>Le Heng Weng</h1>

          <h3>
            {displayText}
            <span className="typing-cursor">|</span>
          </h3>
        </div>

        <a href="#about">
          <img
            src="/assets/other/scroll-down.png"
            alt="scroll down"
            className="img-fade"
          />
        </a>
      </div>
    </div>
  );
}